import { registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

registerDefaultsForModule(
  'formComponents', ({ name, palette, typography }) => {
    const commonTheme = {
      error: {
        fontFamily: typography.fontFamily,
        fontSize: 12,
        color: palette.form.error,
        borderColor: palette.form.error,
        fontWeight: 'normal'
      },
      warning: {
        color: palette.error,
        borderColor: palette.error
      }
    };

    switch (name) {
      case 'ash':
        return {
          ...commonTheme,
          ...ash({ palette, typography })
        };
      default:
        return {
          ...commonTheme,
          ...legacy({ palette, typography })
        };
    }
  }
);
